"use strict";
import Home_vue from '@/vue/apps/home/home.vue'
import Vue from 'vue'
import store from '@/vue/store/'

history.pushState(null, null, location.href);

new Vue({
  el: '#landing',
  template: '<Home></Home>',
  store: store,
  beforeMount() {
    this.$store.commit('ACCOUNT', window.account);
    this.$store.commit('SPORTBETTYPELIST', window.sportBettypeList)
    this.$store.commit('SPORTLIST', _.uniqBy(window.sportBettypeList,'sprtId'))
    var sport_id = 0
    if(window.sprtid != '') {
        const index = this.$store.getters.sportList.findIndex(item => item.sprtId === 'N'+window.sprtid)
        if(index !== -1){
            sport_id = index;
            if(window.selectedMrkt != '') {
              this.$store.commit('SELECTED_MARKET', window.selectedMrkt)
              this.$store.commit('MARKETTOGGLE', window.selectedMrkt)
            }
        }
    }
    this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[sport_id]['sprtId'])
  },
  mounted() {
    let VUE = this
    if(window.navigator.userAgent.indexOf('Safari')<0 && window.navigator.userAgent.indexOf('Chrome')!=-1){
      window.onpopstate = function () {
        VUE.$store.dispatch('redirectReturn')
      };
    }
  },
  components: {
    Home: Home_vue
  },
})



// WEBPACK FOOTER //
// ./resources/score/js/home/home.js